// Indian + International airports for getdeparto
export const AIRPORTS = [
  // Indian (20)
  { code: "DEL", city: "Delhi", country: "India", name: "Indira Gandhi International" },
  { code: "BOM", city: "Mumbai", country: "India", name: "Chhatrapati Shivaji" },
  { code: "BLR", city: "Bangalore", country: "India", name: "Kempegowda International" },
  { code: "HYD", city: "Hyderabad", country: "India", name: "Rajiv Gandhi International" },
  { code: "MAA", city: "Chennai", country: "India", name: "Chennai International" },
  { code: "CCU", city: "Kolkata", country: "India", name: "Netaji Subhash Chandra Bose" },
  { code: "PNQ", city: "Pune", country: "India", name: "Pune Airport" },
  { code: "AMD", city: "Ahmedabad", country: "India", name: "Sardar Vallabhbhai Patel" },
  { code: "COK", city: "Kochi", country: "India", name: "Cochin International" },
  { code: "GOI", city: "Goa", country: "India", name: "Goa International" },
  { code: "JAI", city: "Jaipur", country: "India", name: "Jaipur International" },
  { code: "ATQ", city: "Amritsar", country: "India", name: "Sri Guru Ram Dass Jee" },
  { code: "LKO", city: "Lucknow", country: "India", name: "Chaudhary Charan Singh" },
  { code: "IXC", city: "Chandigarh", country: "India", name: "Chandigarh International" },
  { code: "NAG", city: "Nagpur", country: "India", name: "Dr. Babasaheb Ambedkar" },
  { code: "IDR", city: "Indore", country: "India", name: "Devi Ahilyabai Holkar" },
  { code: "CJB", city: "Coimbatore", country: "India", name: "Coimbatore International" },
  { code: "STV", city: "Surat", country: "India", name: "Surat Airport" },
  { code: "BBI", city: "Bhubaneswar", country: "India", name: "Biju Patnaik International" },
  { code: "TRV", city: "Trivandrum", country: "India", name: "Trivandrum International" },

  // International (30)
  { code: "LHR", city: "London", country: "UK", name: "Heathrow" },
  { code: "CDG", city: "Paris", country: "France", name: "Charles de Gaulle" },
  { code: "FRA", city: "Frankfurt", country: "Germany", name: "Frankfurt Airport" },
  { code: "AMS", city: "Amsterdam", country: "Netherlands", name: "Schiphol" },
  { code: "DXB", city: "Dubai", country: "UAE", name: "Dubai International" },
  { code: "YYZ", city: "Toronto", country: "Canada", name: "Pearson International" },
  { code: "SYD", city: "Sydney", country: "Australia", name: "Kingsford Smith" },
  { code: "JFK", city: "New York", country: "USA", name: "John F. Kennedy" },
  { code: "SIN", city: "Singapore", country: "Singapore", name: "Changi" },
  { code: "BKK", city: "Bangkok", country: "Thailand", name: "Suvarnabhumi" },
  { code: "NRT", city: "Tokyo", country: "Japan", name: "Narita" },
  { code: "KUL", city: "Kuala Lumpur", country: "Malaysia", name: "KLIA" },
  { code: "ZRH", city: "Zurich", country: "Switzerland", name: "Zurich Airport" },
  { code: "VIE", city: "Vienna", country: "Austria", name: "Vienna International" },
  { code: "BRU", city: "Brussels", country: "Belgium", name: "Brussels Airport" },
  { code: "FCO", city: "Rome", country: "Italy", name: "Leonardo da Vinci" },
  { code: "MAD", city: "Madrid", country: "Spain", name: "Barajas" },
  { code: "BCN", city: "Barcelona", country: "Spain", name: "El Prat" },
  { code: "MUC", city: "Munich", country: "Germany", name: "Munich Airport" },
  { code: "ARN", city: "Stockholm", country: "Sweden", name: "Arlanda" },
  { code: "OSL", city: "Oslo", country: "Norway", name: "Gardermoen" },
  { code: "CPH", city: "Copenhagen", country: "Denmark", name: "Kastrup" },
  { code: "HEL", city: "Helsinki", country: "Finland", name: "Helsinki-Vantaa" },
  { code: "WAW", city: "Warsaw", country: "Poland", name: "Chopin" },
  { code: "PRG", city: "Prague", country: "Czechia", name: "Václav Havel" },
  { code: "BUD", city: "Budapest", country: "Hungary", name: "Ferenc Liszt" },
  { code: "ATH", city: "Athens", country: "Greece", name: "Eleftherios Venizelos" },
  { code: "LIS", city: "Lisbon", country: "Portugal", name: "Humberto Delgado" },
  { code: "DUB", city: "Dublin", country: "Ireland", name: "Dublin Airport" },
  { code: "MEL", city: "Melbourne", country: "Australia", name: "Tullamarine" },
];
